function fromTheme(key) {
  var themeGetter = function themeGetter(theme) {
    return theme[key] || [];
  };

  themeGetter.isThemeGetter = true;
  return themeGetter;
}

export { fromTheme };
//# sourceMappingURL=from-theme.mjs.map
